import { useCallback, useState } from "react";

import { translate } from "app/filters/i18nFilter";
import { MAX_CHARACTERS, MIN_CHARACTERS } from "app/pages/activation/components/SetupModal/constants";
import { ERROR_MESSAGES } from "app/pages/activation/components/SetupModal/NameStep/texts";

const useNameInput = (existingNames: (string | undefined)[], initialName = "") => {
    const [activationSetName, setActivationSetName] = useState(initialName);

    const [nameError, setNameError] = useState({
        isError: false,
        errorMessage: "",
    });

    const validateName = useCallback(
        (name: string) => {
            const trimmedName = name.trim();
            const nameLength = trimmedName.length;

            setActivationSetName(name);

            if (nameLength > MAX_CHARACTERS) {
                setNameError({
                    isError: true,
                    errorMessage: translate(ERROR_MESSAGES.MAX_CHARACTERS_REACHED, {
                        max: MAX_CHARACTERS,
                    }),
                });

                return;
            }

            if (nameLength < MIN_CHARACTERS) {
                setNameError({
                    isError: true,
                    errorMessage: translate(ERROR_MESSAGES.TOO_SMALL, { min: MIN_CHARACTERS }),
                });

                return;
            }

            if (trimmedName !== initialName && existingNames?.includes(trimmedName)) {
                setNameError({
                    isError: true,
                    errorMessage: translate(ERROR_MESSAGES.ALREADY_USED, { name }),
                });

                return;
            }

            setNameError({
                isError: false,
                errorMessage: "",
            });
        },
        [existingNames, initialName],
    );

    const onNameChange = useCallback((name: string) => validateName(name), [validateName]);

    return {
        onNameChange,
        setNameError,
        validateName,
        setActivationSetName,
        nameError,
        activationSetName,
    };
};

export default useNameInput;
